class CartNotificationSmall extends HTMLElement {
    constructor() {
        super();
        this.notification = document.getElementById('cart-notification-small');
        this.header = document.querySelector('sticky-header');
        this.onBodyClick = this.handleBodyClick.bind(this);

        this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
            closeButton.addEventListener('click', this.close.bind(this))
        );
    }

    open() {
        this.notification.classList.add('animate', 'active');

        this.notification.addEventListener(
            'transitionend',
            () => {
                this.notification.focus();
                trapFocus(this.notification);
            },
            { once: true }
        );

        document.body.addEventListener('click', this.onBodyClick);

        setTimeout(() => this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
            closeButton.click()
        ), 5000);

    }

    close() {
        this.notification.classList.remove('active');
        document.body.removeEventListener('click', this.onBodyClick);

        removeTrapFocus(this.activeElement);
    }

    renderContents(parsedState) {
        if (this.header) this.header.reveal();
        const productNameElement = document.querySelector('.cart-notification-product');
        if (productNameElement) {
            productNameElement.textContent= parsedState
            const buttonElement = document.createElement('span');
            buttonElement.id = 'cart-notification-button';
            buttonElement.onclick = function () {
                this.closest('.section-header').querySelector('.header__icon--cart').click();
            };
            buttonElement.innerHTML = ` ${addedTranslation} <strong>${cartTranslation}</strong>`;

            productNameElement.appendChild(buttonElement);
        }

        this.open();

    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-notification-product',
                selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
            },
        ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    handleBodyClick(evt) {
        const target = evt.target;
        if (target !== this.notification && !target.closest('cart-notification')) {
            const disclosure = target.closest('details-disclosure, header-menu');
            this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
            this.close();
        }
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-notification-small', CartNotificationSmall);
